import { Component, OnInit } from '@angular/core';
import { BrowseobligorService } from '../services/browseobligor.service';
import { Webcast } from '../Models/webcast';
declare var $: any;
declare const WebCastPageLoad: any;
declare function WebCastresponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare function WebcastOpneModelMessage(eventId, innerText): any;
declare function HomeresponsiveVoiceSpeak(placeholder, inputValue, keyCode, innerText, eventId, controlType, title, htmlFor, alt, key): any;
declare function FontSizeSettings(): any;
var webcastTabIndex = 0;
var webcastCloseVoice = 0;

@Component({
  selector: 'app-accessingwebcasts',
  templateUrl: './accessingwebcasts.component.html',
  styleUrls: ['./accessingwebcasts.component.css']
})
export class AccessingwebcastsComponent implements OnInit {



 //allWebcast= [
  //  {
  //    "webcastDateAndTime": "06/14/2018 09:00:00",
  //    "description": "Avon Grove Charter School - Investor Conference Call",
  //    "url": "https://216.34.174.212/GetContent?id=0900bbc780211627&inline=1"
  //  },
  //  {
  //    "webcastDateAndTime": "  01/28/2019 10:00:00",
  //    "description": "Avon Grove Charter School Bondholder Conference Call Recording",
  //    "url": "https://216.34.174.212/GetContent?id=0900bbc780211627&inline=1"
  //  }
  //];

  constructor(private browseobligorService: BrowseobligorService) { }

  ngOnInit() {
    //debugger;
    //=========Caption Hide Show=============//
    if ($('#hidglbVarOnOff').val() == "OFF") {
      $('#captionhideshow').hide();
      $('#btnOnOff').val('OFF')
    }
    else {
      $('#captionhideshow').show();
      $('#btnOnOff').val('ON')
    }

    //============Voice Annotation On/Off=========
    if ($('#hidVoiceOnOff').val() == "OFF") {
      $('#btnVoiceAnnotation').val('OFF');
      $('#hidVoiceOnOff').val('OFF');
      $('#btnPlayPause').css('display', 'none');
    }
    else {
      $('#btnVoiceAnnotation').val('ON');
      $('#hidVoiceOnOff').val('ON');
      $('#btnPlayPause').css('display', 'block');
    }

    WebCastPageLoad();
    this.loadWebcast(localStorage.OBLIGOR_ID);   

    $('#myModalvideo').on('shown.bs.modal', function () {
      debugger;
      $('#divwebcastVideo').focus();
      WebcastOpneModelMessage("PlayWebcast", "");
      webcastCloseVoice = 0;      
    });

    $("#myModalvideo").on("hidden.bs.modal", function () {
      debugger;      
      var webcastDateID = "webcastDateID_" + webcastTabIndex;
      if (document.getElementById(webcastDateID) == null) {
        document.getElementById("SkipMainContentfooter").focus();
        HomeresponsiveVoiceSpeak("", "", 9, "Skip the Footer", "SkipMainContent", "", "", "", "", "Tab");
      }
      else {
        document.getElementById(webcastDateID).focus();
        WebcastOpneModelMessage("btnPlayWebcast", document.getElementById(webcastDateID).innerText);
      }
      return;
    });
  }

  closeVideo() {
    debugger;
    var vid = <HTMLVideoElement>document.getElementById("webcastVideo");
    vid.pause();    
  }

  showModal(documentLink, tabindex) {
    debugger;
    $("#webcastVideo").attr("src", documentLink);
    webcastTabIndex = tabindex + 1;
  }

  onKeyUpPlayPause(event: any) {
    debugger;
    var vid = <HTMLVideoElement>document.getElementById("webcastVideo");
    if (vid.paused == true) {
      vid.play();
    }
    else {
      vid.pause();
    }    
    return;
  }

  onKeyUp(event: any, documentLink, tabindex) {
    debugger;
    if (event.target.id == "myModalvideo" && event.keyCode == 9) {
      $('#divwebcastVideo').focus();
      webcastCloseVoice = 0;      
      return;
    }
    if (event.target.id == "divwebcastVideo" && event.keyCode == 16) {
      webcastCloseVoice = 0;      
    }

    if (event.target.id == "btnWebcastClose" && event.keyCode == 9 && webcastCloseVoice == 0) {
      WebcastOpneModelMessage("btnWebcastClose", "");
      webcastCloseVoice = 1;
      return;
    }

    if (event.target.id == "lblHoldModelNext") {
      $('#btnWebcastClose').focus();
      WebcastOpneModelMessage("btnWebcastClose", "");
      return;
    }
    if (event.target.id == "lblHoldModelPrev") {
      $('#divwebcastVideo').focus();      
      return;
    }

    //if (event.target.id == "divwebcastVideo" && event.keyCode == 32 && webcastPlayPause == 0) {
    //  var vid = <HTMLVideoElement>document.getElementById("webcastVideo");
    //  if (vid.paused == true) {
    //    vid.play();
    //  }
    //  else {
    //    vid.pause();
    //  }    
    //  return;
    //}
    if (event.target.id == "webcastVideo" && event.keyCode == 27) {
      $('#btnWebcastClose').focus();
      WebcastOpneModelMessage("btnWebcastClose", "");
      return;
    }
    if (event.keyCode == 13 || event.keyCode == 9) {
      if (event.keyCode == 13) {
        if (event.target.id == "PlayID") {
          $("#webcastVideo").attr("src", documentLink);
          $("#myModalvideo").modal('show');
          webcastTabIndex = tabindex + 1;
          return;
        }
      }
      else {
        WebCastresponsiveVoiceSpeak(event.target.placeholder, event.target.value, event.keyCode, event.target.innerText, event.target.id, event.target.type, event.target.title, event.target.htmlFor, event.target.alt, event.key);
      }
    }
  };

  setFontSizeSettings() {    
    FontSizeSettings();
  }

  public allWebcast: Webcast;

  loadWebcast(obligorId: string) {
    debugger;
    this.browseobligorService.GetWebCast(obligorId).subscribe(data => {
      //debugger;
      if (data['length'] > 0) {
        this.allWebcast = data;        
      }      
    });
  }

}
